'use strict';

import AppDispatcher from '../AppDispatcher';
import ActionTypes from '../constants/ActionTypes';
import ModalTypes from '../constants/ModalTypes';
import PayloadSources from '../constants/PayloadSources';
import UserStore from '../stores/UserStore';
import { createStore } from '../utils/StoreUtils';
import config from 'config';

var _alert = null,
    _sidebar = null,
    _contextMenu = null,
    _modal = null,
    _isFacebookOwnModalVisible = false,
    _isModalSpecifiedByServer = false;

function is(entity, id) {
  if (entity) {
    return !id || entity.id === id;
  } else {
    return false;
  }
}

function hideAlert() {
  _alert = null;
}

function hideSidebar() {
  _sidebar = null;
}

function hideContextMenu() {
  _contextMenu = null;
}

function canHideModal(modal) {
  if (modal && modal.id && _modal) {
    return modal.id === _modal.id;
  }

  if (config.isAuthPopup) {
    return false;
  }

  switch (_modal && _modal.id) {
  case ModalTypes.RESET_PASSWORD:
    return false;
  case ModalTypes.SIGNUP:
  case ModalTypes.FINISH_SIGNUP:
    const justSignedUp = UserStore.isAuthenticated();
    return !justSignedUp;
  case ModalTypes.SEND_INVITE:
    return !_isFacebookOwnModalVisible;
  default:
    return true;
  }
}

function hideModal(modal) {
  if (!canHideModal(modal)) {
    return;
  }

  _isModalSpecifiedByServer = false;
  if (_modal && _modal.next) {
    _modal = _modal.next;
  } else {
    _modal = null;
  }
}

function hideAll() {
  hideAlert();
  hideSidebar();
  hideContextMenu();
  hideModal();
}

function showAlert(alert) {
  hideAll();
  _alert = alert;
}

function showSidebar(sidebar) {
  hideAll();
  _sidebar = sidebar;
}

function showContextMenu(contextMenu) {
  hideAll();
  _contextMenu = contextMenu;
}

function showModal(modal, isPreloaded) {
  hideAll();
  _modal = modal;
  _isModalSpecifiedByServer = isPreloaded || false;
}

function shouldHideModalOnRouteChange() {
  return !_isModalSpecifiedByServer;
}

function shouldHideAlertOnRouteChange() {
  // By default true, unless explicitly set to false
  return _alert && _alert.hideOnRouteChange !== false;
}

function handleRouteChange() {
  if (shouldHideModalOnRouteChange()) {
    hideModal();
  }

  if (shouldHideAlertOnRouteChange()) {
    hideAlert();
  }

  hideContextMenu();
  hideSidebar();
}

var OverlayStore = createStore({
  hasAlert(id) {
    return is(_alert, id);
  },

  hasSidebar(id) {
    return is(_sidebar, id);
  },

  hasModal(id) {
    return is(_modal, id);
  },

  hasContextMenu(id) {
    return is(_contextMenu, id);
  },

  hasAny() {
    return this.hasAlert() ||
           this.hasSidebar() ||
           this.hasModal() ||
           this.hasContextMenu();
  },

  getAlert() {
    return _alert;
  },

  getSidebar() {
    return _sidebar;
  },

  getModal() {
    return _modal;
  },

  getContextMenu() {
    return _contextMenu;
  },

  canHideModal() {
    return canHideModal();
  }
});


AppDispatcher.register(function (payload) {
  var action = payload.action;

  switch (action.type) {
  case ActionTypes.SHOW_ALERT:
    showAlert(action.alert);
    OverlayStore.emitChange();
    break;

  case ActionTypes.HIDE_ALERT:
    hideAlert();
    OverlayStore.emitChange();
    break;

  case ActionTypes.SHOW_SIDEBAR:
    showSidebar(action.sidebar);
    OverlayStore.emitChange();
    break;

  case ActionTypes.HIDE_SIDEBAR:
    hideSidebar();
    OverlayStore.emitChange();
    break;

  case ActionTypes.SHOW_CONTEXT_MENU:
    showContextMenu(action.contextMenu);
    OverlayStore.emitChange();
    break;

  case ActionTypes.HIDE_CONTEXT_MENU:
    hideContextMenu();
    OverlayStore.emitChange();
    break;

  case ActionTypes.SHOW_MODAL:
    showModal(action.modal, payload.source === PayloadSources.PRELOADED_ACTION);
    OverlayStore.emitChange();
    break;

  case ActionTypes.HIDE_MODAL:
    hideModal(action.modal);
    OverlayStore.emitChange();
    break;

  case ActionTypes.SEND_FB_INVITE:
    _isFacebookOwnModalVisible = true;
    OverlayStore.emitChange();
    break;

  case ActionTypes.SEND_FB_INVITE_SUCCESS:
  case ActionTypes.SEND_FB_INVITE_ERROR:
    _isFacebookOwnModalVisible = false;
    OverlayStore.emitChange();
    break;

  case ActionTypes.HIDE_OVERLAY:
    hideAll();
    OverlayStore.emitChange();
    break;

  case ActionTypes.CHANGE_ROUTE:
    handleRouteChange();
    OverlayStore.emitChange();
    break;
  }
});

export default OverlayStore;


/** WEBPACK FOOTER **
 ** ./stores/OverlayStore.js
 **/